import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findBestDistrictFromText } from "../data/koreaDistricts";

/**
 * Catch-all 404 redirector with smart district detection.
 *
 * 우선순위:
 * 1. URL(path + decoded)에 전국 시/구 이름이 포함되어 있으면
 *    → /rental/<regionShort>/<districtName> 으로 리다이렉트
 * 2. 그 외 → / 로 이동
 *
 * 추가 처리:
 * - 레거시 /product/:slug/:id/ 형태 (구글에 인덱스된 옛 URL) 도 동일 로직 적용
 * - URL 인코딩된 한글(%EC%86%A1%ED%8C%8C ...) 도 디코딩하여 검색
 */
export default function SmartRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let target = "/";
    try {
      const raw = (location.pathname || "") + (location.search || "");
      let decoded = raw;
      try { decoded = decodeURIComponent(raw); } catch (_) { /* keep raw */ }
      const haystack = `${raw} ${decoded}`;

      const hit = findBestDistrictFromText(haystack);

      if (hit) {
        const region = hit.regionShort;
        if (region) {
          target = `/rental/${encodeURIComponent(region)}/${encodeURIComponent(hit.name)}`;
        } else {
          target = `/rental`;
        }
      }
    } catch (_) {
      target = "/";
    }
    navigate(target, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return (
    <div style={{ padding: 60, textAlign: "center", color: "#86868b", fontSize: 13 }}>
      페이지를 찾는 중입니다...
    </div>
  );
}
